import { useTranslation } from 'react-i18next'

import { useAuth } from '../../hooks/useAuth'

const Dashboard = () => {
  const { t } = useTranslation()
  const { getUserInfo } = useAuth()
  const userProfile = getUserInfo()

  return (
    <div className="p-6">
      {userProfile && userProfile.name ? (
        <h1 className="text-4xl p-2 text-left">
          {t('Dashboard.Welcome', { name: userProfile.name })}
        </h1>
      ) : (
        <div>
          <h1 className="text-4xl p-2 text-left">{t('Dashboard.Welcome')}</h1>
          <p>{t('Dashboard.NoUserInfo')}</p>
        </div>
      )}
    </div>
  )
}

export default Dashboard
